const initDropdowns = function () {
    document.querySelectorAll('[data-toggle="dropdown"]').forEach(item => {
        item.addEventListener('click', event => {
            event.stopPropagation();
            event.target.closest('[data-toggle="dropdown"]').parentNode.querySelector('.dropdown-menu').classList.toggle('show');
        })
    })

    document.body.addEventListener('click', event => {
        document.querySelectorAll('.dropdown-menu.show').forEach(item => {
            item.classList.remove('show');
        })
    })
}

export default initDropdowns;